import { render, staticRenderFns } from "./optionbuttonmulti.vue?vue&type=template&id=94c4d31e&"
import script from "./optionbuttonmulti.vue?vue&type=script&lang=js&"
export * from "./optionbuttonmulti.vue?vue&type=script&lang=js&"
import style0 from "./optionbuttonmulti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports